export default class {
    _id;
    _postCode;
    _name;
    _parent;
    _postRegionCode;
    _postDistrictCode;
    _isActive;


    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get postCode() {
        return this._postCode;
    }

    set postCode(value) {
        this._postCode = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get parent() {
        return this._parent
    }

    set parent(value) {
        this._parent = value
    }

    get postRegionCode() {
        return this._postRegionCode
    }

    set postRegionCode(value) {
        this._postRegionCode = value
    }

    get postDistrictCode() {
        return this._postDistrictCode
    }

    set postDistrictCode(value) {
        this._postDistrictCode = value
    }

    get isActive() {
        return this._isActive;
    }

    set isActive(value) {
        this._isActive = value;
    }

    constructor(id, postCode, name, regionId, areaId, isActive) {
        this._id = id;
        this._postCode = postCode;
        this._name = name;
        this._parent = null;
        this._postRegionCode = regionId;
        this._postDistrictCode = areaId;
        this._isActive = isActive;
    }
}